import { crearCliente } from '@tallerya/api-client';
import { vigilarSuspension } from './permisos/suspension';
import { gestorSesion } from './sesion/gestor';
import { tallerActivo } from './taller/tallerActivo';

// El cliente de la API para este sitio. **Uno solo, creado una vez.**
//
// Crear uno por pantalla parece inofensivo y deja de serlo en cuanto haya más
// middleware: el que traduce errores, el que reintenta. Cada copia tendría que
// enterarse por su cuenta.
//
// ## De dónde sale la dirección
//
// De `VITE_API_URL`, porque no es la misma en las tres partes donde corre esto:
// la máquina de un dev, el servidor de dev y, algún día, producción. El valor
// por omisión es el puerto que usa `dotnet run` —el mismo que documenta
// CLAUDE.md— para que clonar el repo y levantar las dos mitades funcione sin
// configurar nada.
const baseUrl = import.meta.env.VITE_API_URL ?? 'http://localhost:5249';

export const api = crearCliente({
  baseUrl,

  // El token se pide **en cada petición**, no una vez al crear el cliente.
  //
  // Con cinco minutos de vida y renovación silenciosa detrás, guardarlo acá
  // significaría mandar uno vencido a los pocos minutos. `getUser()` devuelve
  // siempre el que está vigente en ese instante.
  //
  // Se lee del gestor y no del contexto de React a propósito: este archivo no
  // es un componente, y el token hace falta en peticiones que salen fuera de un
  // dibujado. El gestor es el mismo que usa `ProveedorSesion`, así que no hay
  // dos versiones de la verdad.
  obtenerToken: async () => {
    const usuario = await gestorSesion.getUser();

    // Sin sesión, o con una vencida que no se alcanzó a renovar, se manda la
    // petición sin credenciales y la API responde 401. Es lo correcto: quien
    // decide si algo se puede hacer es el servidor, y un 401 explícito se puede
    // manejar —mandar a entrar de nuevo— mientras que una petición que nunca
    // sale solo deja la pantalla en blanco.
    if (!usuario || usuario.expired) return undefined;

    return usuario.access_token;
  },

  // En qué taller trabaja esta pestaña (#205), en la cabecera `X-Tenant-Id`. La
  // API solo la acepta si ese taller viene firmado en el token; ver
  // `taller/tallerActivo.ts`. Antes de elegir —la pregunta de en qué talleres
  // está la persona— no se manda nada.
  obtenerTaller: tallerActivo,
});

// Con el admin abierto, un taller que suspenden se nota en la siguiente petición
// de cualquier pantalla (#244).
api.use(vigilarSuspension);

export { baseUrl as direccionApi };
